module.exports = __webpack_public_path__ + "static/media/S4N5-2.3296ac45.svg";